import { render, staticRenderFns } from "./BMap.vue?vue&type=template&id=7c37f171&scoped=true&"
import script from "./BMap.vue?vue&type=script&lang=js&"
export * from "./BMap.vue?vue&type=script&lang=js&"
import style0 from "./BMap.vue?vue&type=style&index=0&id=7c37f171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c37f171",
  null
  
)

export default component.exports